import { FC } from 'react'
import { AppHead } from 'client/components/Layout/components/AppHead/AppHead'
import { RefundPageContent } from 'client/contents/RefundPageContent/RefundPageContent'
import { useTranslation } from 'react-i18next'
import { ClientLocaleNS } from 'lib/constants/locales'

type TProps = {}

const RefundPage: FC<TProps> = () => {
  const { t } = useTranslation(ClientLocaleNS.RefundPage)
  return (
    <article className="bg-surface-white flex h-full w-full flex-col">
      <AppHead title={t('title')} />
      <RefundPageContent />
    </article>
  )
}

export default RefundPage
